import { AnalyticIdentifier } from '@common/neo.tax';
import { Alert, colors, Stack, Typography } from '@ui-components/neo.tax';
import { ReactComponent as SupportTicketIcon } from '@ui-components/neo.tax/dist/icons/support-ticket.svg';
import { ReactElement } from 'react';

import { RdProject } from '@neo.tax/rd/hooks';
import { ProcessingProjectState, useAnalyticId } from '@neo.tax/shared';
import { OrganizationMember } from '@neo.tax/shared/hooks/useCurrentUser';

import { DeleteRdProject } from '../delete-rd-project';
import { RdProjectDetailForm } from '../rd-project-detail-form';
import { RdProjectDocumentUploadForm } from '../rd-project-document-upload-form';
import { StyledDangerZone, StyledDivider, StyledStack, StyledTicketSection } from './rd-project-detail-pane.styled';

type RdProjectDetailProps = {
  rdProject: RdProject;
  members: OrganizationMember[];
};

export const RdProjectDetailPane = ({ members, rdProject }: RdProjectDetailProps): ReactElement => {
  const isProcessingDocuments = rdProject.processingState === ProcessingProjectState.InProgress;
  const deleteButtonId = useAnalyticId(AnalyticIdentifier.RD_PROJECT_DELETE_BUTTON);
  const deleteConfirmationButtonId = useAnalyticId(AnalyticIdentifier.RD_PROJECT_DELETE_CONFIRMATION_BUTTON);

  return (
    <StyledStack direction="column" paddingX={4} paddingY={4}>
      {isProcessingDocuments && (
        <Alert
          severity="warning"
          title="We are currently analyzing the documents to generate the project narrative. Uploading more documents is disabled until we finish."
        />
      )}
      <RdProjectDetailForm rdProject={rdProject} members={members} />
      <RdProjectDocumentUploadForm rdProject={rdProject} />
      <StyledTicketSection direction="column" gap={6}>
        <Stack gap={2}>
          <SupportTicketIcon width={20} fill={colors.gray[400]} />
          <Typography fontSize="sm" fontWeight="medium">
            {rdProject.ticketCount}
          </Typography>
          <Typography fontSize="sm">Tickets</Typography>
        </Stack>
      </StyledTicketSection>
      <StyledDangerZone direction="column" gap={3}>
        <StyledDivider />
        <DeleteRdProject
          rdProject={rdProject}
          analyticIds={{
            deleteButtonId,
            deleteConfirmationButtonId,
          }}
        />
      </StyledDangerZone>
    </StyledStack>
  );
};
